<co-base-confirm-modal
  [title]="title"
  [cancelButtonTranslationKey]="cancelButtonTranslationKey"
  [confirmButtonTranslationKey]="confirmButtonTranslationKey"
  (dismiss)="onDismiss()"
  (confirm)="onConfirm()"
  >{{ message }}
</co-base-confirm-modal>
